import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMerchantAuth } from '../../../contexts/MerchantAuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';
import TermsAcceptanceModal from './TermsAcceptanceModal';

const MerchantProtectedRoute = ({ children }) => {
  const { merchant, loading, isAuthenticated, isEmailVerified } = useMerchantAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
      >
        <CircularProgress size={40} />
        <Typography variant="h6" sx={{ mt: 2 }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  if (!merchant) {
    // Not logged in, redirect to login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isEmailVerified()) {
    // Email not verified, redirect to verification
    return <Navigate to="/verify-email" state={{ email: merchant.email }} replace />;
  }

  if (!isAuthenticated()) {
    // Account inactive or other auth issues
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const consentStatus = merchant.latest_consent_status;
  const showConsentModal = consentStatus && (!consentStatus.terms_accepted || !consentStatus.privacy_accepted);

  return (
    <>
      {children}
      <TermsAcceptanceModal open={!!showConsentModal} consentStatus={consentStatus} />
    </>
  );
};

export default MerchantProtectedRoute; 